import { render } from "./ListeAssignPage.vue?vue&type=template&id=311c7f6a&ts=true"
import script from "./ListeAssignPage.vue?vue&type=script&lang=ts"
export * from "./ListeAssignPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__